module.exports = __webpack_public_path__ + "static/media/styledSchedule.ab82e035.svg";